"use client";

import { Box } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import React from "react";

interface AlertProps {
  message: string;
}

const AlertMessage: React.FC<AlertProps> = (props) => {
  return (
    <Box className="flex items-center font-medium tracking-wide text-orange text-xs mt-1 gap-1 leading-normal">
      <InfoCircledIcon />
      {props?.message}
    </Box>
  );
};

export default AlertMessage;
